/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-const */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from 'react';
import {
  AppShell,
  Navbar,
  Paper,
  Group,
  Title,
  ScrollArea,
  Aside,
  Modal,
  Divider,
  Space,
  ActionIcon,
  Text,
  Stack,
  Input,
  Box,
  Center,
  MediaQuery,
  useMantineTheme,
  Button,
  Image,
  Checkbox,
  NumberInput,
} from '@mantine/core';
import dayjs from 'dayjs';
import { showNotification } from '@mantine/notifications';
import { DatePicker } from '@mantine/dates';
import { CircleX, Calendar, Edit, EditOff } from 'tabler-icons-react';
import Keyboard from 'react-simple-keyboard';
import { sendRequest } from '../../services/services';
import LandingLayout from '../../components/LandingLayout';
import VerifyRefund from './VerifyRefund';
import Profile from '../Profile/profile';
import cashIcon from '../../image/cash.png';
import cardIcon from '../../image/card.png';

const Refund = () => {
  const theme = useMantineTheme();
  const [inputs, setInputs] = useState({});
  const [confirmRefund, setConfirmRefund] = useState(false);
  const [verifyRefund, setVerifyRefund] = useState(false);
  const [layoutName, setLayoutName] = useState('default');
  const [inputName, setInputName] = useState('default');
  const [ticketData, setTicketData] = useState();
  const [passIdData, setPassIdData] = useState();
  const [invoiceData, setInvoiceData] = useState();
  const [originalData, setOriginalData] = useState();
  const [selectedVas, setSelectedVas] = useState([]);
  const [refundAmount, setRefundAmount] = useState(0);
  const [dateValue, setDateValue] = useState();
  const [checked, setChecked] = useState(false);
  const keyboard = useRef();
  const [dataChange, setDataChange] = useState([]);
  const [checkData, setCheckData] = useState();
  const [profileData, setProfileData] = useState({});
  const [refundInfo, setRefundInfo] = useState({});
  const [isMobileEdit, setIsMobileEdit] = useState(false);
  const [checkId, setCheckId] = useState();
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (passIdData) {
      sendRequest(`cashier/reservations-by-pass-id/${passIdData}`, 'get')
        .then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        });
    }
  }, [passIdData]);

  const onChangeAll = (inputsValue) => {
    /**
     * Here we spread the inputs into a new object
     * If we modify the same object, react will not trigger a re-render
     */
    setInputs({ ...inputsValue });
    // setInputInvoiceNumber(...inputs);
    // setInputMobileNumber(inputsValue);
    setTouched(true);
  };

  const handleShift = () => {
    const newLayoutName = layoutName === 'default' ? 'shift' : 'default';
    setLayoutName(newLayoutName);
  };

  const onKeyPress = (button) => {
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}') {
      searchInvoice();
    }
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;

    setInputs({
      ...inputs,
      [inputName]: inputVal,
    });
    keyboard.current.setInput(inputVal);
    setTouched(true);
  };

  const getInputValue = (inputNameValue) => inputs[inputNameValue] || '';

  const now = dayjs();
  const date1 = dayjs(ticketData?.result?.start_time);
  const date2 = dayjs(
    !ticketData?.result?.end_time
      ? now
      : !ticketData?.result?.tickets?.exit_time
      ? ticketData?.result?.end_time
      : ticketData?.result?.tickets?.exit_time,
  );
  const TotalSeconds = date2.diff(date1, 'minutes');
  const hours = Math.ceil(TotalSeconds / 60);
  const startDate = dayjs(ticketData?.result?.start_time).format('DD-MM-YYYY HH:mm').slice(0, -5);
  const startTime = dayjs(ticketData?.result?.start_time).format('DD-MM-YYYY HH:mm').slice(10);

  const endDate = dayjs(
    ticketData?.result?.tickets?.ticket_status_types?.id === 3
      ? ticketData?.result?.tickets?.exit_time
      : !ticketData?.result?.end_time
      ? now
      : ticketData?.result?.end_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(0, -5);
  const endTime = dayjs(
    ticketData?.result?.tickets?.ticket_status_types?.id === 3
      ? ticketData?.result?.tickets?.exit_time
      : !ticketData?.result?.end_time
      ? now
      : ticketData?.result?.end_time,
  )
    .format('DD-MM-YYYY HH:mm')
    .slice(10);

  const firstDate = dayjs(dateValue).format('DD/MM/YYYY');

  const invoiceDate = dayjs(invoiceData?.payment_transactions[0]?.updated_at).format('DD/MM/YYYY');

  const invoiceId = getInputValue('invoiceNumber');
  const searchInvoice = () => {
    sendRequest(`cashier/invoice/${invoiceId}`, 'get')
      .then((res) => {
        if (res?.code === 20) {
          setInvoiceData(res?.data);
          setOriginalData(
            res?.data?.invoice_items?.map((d) => {
              d.initialUnit = d.unit;
              return d;
            }),
          );
          firstDate !== invoiceDate
            ? showNotification({
                title: <Text weight={500}>Invalid Ticket!</Text>,
                icon: <CircleX size={16} />,
              })
            : null;
          setPassIdData(res?.data?.reservations?.pass_id);
        } else if (invoiceData?.id && firstDate !== invoiceDate) {
          showNotification({
            title: <Text weight={500}>Invalid Ticket!</Text>,
            icon: <CircleX size={16} />,
          });
        } else {
          showNotification({
            title: <Text weight={500}>Invalid Ticket!</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  const conirmRefundModel = () => {
    setVerifyRefund(true);
    setConfirmRefund(false);
  };

  const fetchProfile = () => {
    sendRequest(`cashier/profile`, 'get').then((res) => {
      setProfileData(res?.data || []);
    });
  };

  useEffect(() => {
    fetchProfile();
    setTimeout(fetchProfile(), 2000);
  }, []);

  useEffect(() => {
    const siteId = `?site_id=${
      profileData?.user__site__assign?.filter((item) => item?.is_active)[0]?.sites?.id
    }`;

    sendRequest(`cashier/cashier-refund-info/${siteId}`, 'get').then((res) => {
      setRefundInfo(res?.data || []);
    });
  }, [profileData?.user__site__assign]);

  const mobileEdit = () => {
    setIsMobileEdit(!isMobileEdit);
  };
  const showError =
    touched &&
    ((inputs?.mobileNumber?.length ?? 0) < 7 || (inputs?.mobileNumber?.length ?? 0) > 12);

  return (
    <LandingLayout className="no-printme">
      <div>
        <AppShell
          style={{
            position: 'fixed',
            width: '1000px',
          }}
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
            },
          }}
          navbarOffsetBreakpoint="sm"
          asideOffsetBreakpoint="sm"
          navbar={
            <Navbar
              p="md"
              hiddenBreakpoint="sm"
              width={{ sm: 330, lg: 400 }}
              className="no-printme"
            >
              <div style={{ margin: '10px 0 8px 0px' }}>
                <Center py="xs">
                  <Text>Enter Invoice Number</Text>
                </Center>
                {/* <Input value={inputData} />
                <Input value={inputMobileData} /> */}
                <Stack>
                  <Input
                    id="invoiceNumber"
                    value={getInputValue('invoiceNumber')}
                    onFocus={() => setInputName('invoiceNumber')}
                    placeholder="Invoice Number"
                    onChange={onChangeInput}
                  />
                  <DatePicker
                    placeholder="Pick date"
                    inputFormat="MM/DD/YYYY"
                    labelFormat="MM/YYYY"
                    value={dateValue}
                    defaultValue={new Date()}
                    onChange={setDateValue}
                    icon={<Calendar size={16} />}
                  />
                </Stack>
                <Space h="xl" />
                <Box style={{ width: '300px' }}>
                  <Keyboard
                    keyboardRef={(r) => (keyboard.current = r)}
                    inputName={inputName}
                    layoutName={layoutName}
                    onChangeAll={onChangeAll}
                    onKeyPress={onKeyPress}
                    maxLength={12}
                    layout={{
                      default: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                      shift: ['1 2 3', '4 5 6', '7 8 9', ' 0 {bksp}'],
                    }}
                    display={{
                      '{bksp}': '⌫',
                      '{enter}': 'Enter',
                    }}
                  />

                  <Keyboard
                    keyboardRef={(r) => (keyboard.current = r)}
                    onChangeAll={onChangeAll}
                    onKeyPress={onKeyPress}
                    layoutName={layoutName}
                    maxLength={2}
                    layout={{
                      default: ['{enter}'],
                      shift: ['{enter}'],
                    }}
                    display={{
                      // '{enter}': 'Enter',
                      '{enter}': 'Enter',
                    }}
                  />
                </Box>
              </div>
            </Navbar>
          }
          aside={
            <MediaQuery smallerThan="sm" styles={{ display: 'none' }} className="no-printme">
              <Aside p="md" hiddenBreakpoint="sm" width={{ sm: 220, lg: 240 }}>
                <Profile />
              </Aside>
            </MediaQuery>
          }
        >
          <Box style={{ width: '470px', margin: '-25px 0 0 -38px' }} className="no-printme">
            {invoiceData?.id && firstDate === invoiceDate ? (
              <Paper shadow="lg" withBorder p="xl">
                <Stack>
                  <Group position="apart" style={{ marginBottom: '-20px' }}>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            Entry
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {startDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {startTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                    <ActionIcon
                      color="dark"
                      size="xl"
                      radius="xl"
                      variant="default"
                      sx={{
                        borderColor: 'black',
                        width: '80px',
                        height: '80px',
                        borderRadius: '50px',
                      }}
                    >
                      <Text weight={900} size="lg">
                        {hours === 0 ? 1 : hours} hrs
                      </Text>
                    </ActionIcon>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            Exit
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {endDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {endTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                  </Group>
                  <Space h="xs" />
                  <ScrollArea style={{ height: 150 }} offsetScrollbars scrollbarSize={2}>
                    <Group>
                      <Stack>
                        <Title size="sm" order={2}>
                          Description
                        </Title>
                        <Group>
                          <Stack>
                            {invoiceData?.invoice_items?.map((item) => (
                              <Checkbox
                                size="xs"
                                label={
                                  <Center>
                                    <Text size="sm" weight={500} color="#817E7E">
                                      {item?.invoice_item_list?.name || item?.invoice_item_list}
                                    </Text>
                                  </Center>
                                }
                                onChange={(e) => {
                                  setChecked(e.currentTarget.checked);
                                  setCheckId(item?.id);
                                  // if (e.currentTarget.checked) {
                                  //   setSelectedVas([
                                  //     ...selectedVas,
                                  //     {
                                  //       id: parseInt(item.id, 10),
                                  //       qty: item.unit,
                                  //     },
                                  //   ]);
                                  // } else {
                                  //   setSelectedVas(
                                  //     selectedVas.filter(
                                  //       (people) => people.id !== item.id
                                  //     )
                                  //   );
                                  // }
                                }}
                                value={selectedVas}
                              />
                            ))}
                          </Stack>
                          {/* <Stack>
                            {invoiceData?.invoice_items?.map((item) => (
                              <Text size="sm" weight={500} color="#817E7E">
                                {item?.invoice_item_list?.name || item?.invoice_item_list}
                              </Text>
                            ))}
                          </Stack> */}
                        </Group>
                        {ticketData?.result?.enforcements.map((em) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {em?.name}
                          </Text>
                        ))}

                        <Text size="sm" weight={500} color="#817E7E">
                          Tax ( 15% )
                        </Text>
                      </Stack>
                      <Stack>
                        <Title size="sm" order={2}>
                          Unit Cost
                        </Title>

                        {invoiceData?.invoice_items.map((item) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {!item?.unit_price ? 0 : item?.unit_price}
                          </Text>
                        ))}

                        {ticketData?.result?.enforcements.map((em) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {em?.amount}
                          </Text>
                        ))}

                        <Text size="sm" weight={500} color="#817E7E">
                          {ticketData?.result?.invoices?.tax}
                        </Text>
                      </Stack>

                      <Stack>
                        <Title size="sm" order={2}>
                          Quantity
                        </Title>

                        {invoiceData?.invoice_items.map((item, index) => (
                          <>
                            {checkId === item?.id && checked ? (
                              <NumberInput
                                defaultValue={item?.unit}
                                style={{ width: '60px', marginBottom: '-7px' }}
                                type="number"
                                min={0}
                                max={item?.initialUnit}
                                size="xs"
                                onChange={(e) => {
                                  if (index !== -1) {
                                    invoiceData.invoice_items[index] = {
                                      ...item,
                                      unit: e,
                                      amount: item?.unit_price * e,
                                    };

                                    setRefundAmount(
                                      (previousState) =>
                                        // eslint-disable-next-line no-unused-expressions
                                        previousState + (item?.amount - item?.unit_price * e),
                                    );

                                    setDataChange(invoiceData);

                                    // var indexValue = selectedVas.indexOf(
                                    //   item?.id
                                    // );
                                    // if (
                                    //   indexValue === -1 &&
                                    //   item?.initialUnit !== item?.unit
                                    // ) {
                                    //   setSelectedVas((prevVas) => {
                                    //     const result = [...prevVas];
                                    //     result[index] = {
                                    //       id: item?.id,
                                    //       qty: e.target.value,
                                    //     };
                                    //     return result;
                                    //   });
                                    // } else {
                                    //   selectedVas[0] = {
                                    //     id: item?.id,
                                    //     qty: item?.unit,
                                    //   };
                                    // }

                                    let indexValue = selectedVas.indexOf(index);
                                    if (indexValue === -1) {
                                      setSelectedVas([
                                        ...selectedVas,
                                        {
                                          id: parseInt(item.id, 10),
                                          qty: e,
                                        },
                                      ]);
                                      // setSelectedVas((prevVas) => {
                                      //   const result = [...prevVas];
                                      //   result[index] = {
                                      //     id: parseInt(item.id, 10),
                                      //     qty: e.target.value,
                                      //   };
                                      //   return result;
                                      // });
                                    } else {
                                      selectedVas[0] = {
                                        id: parseInt(item.id, 10),
                                        qty: e,
                                      };
                                    }
                                  }
                                }}
                              />
                            ) : (
                              <Text size="sm" weight={500} color="#817E7E">
                                {item?.unit}
                              </Text>
                            )}
                          </>
                        ))}

                        {ticketData?.result?.enforcements.map((em) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {em ? 1 : 0}
                          </Text>
                        ))}
                        <Text size="sm" weight={500} color="#817E7E">
                          1
                        </Text>
                      </Stack>

                      <Stack>
                        <Title size="sm" order={2}>
                          Amount
                        </Title>

                        {invoiceData?.invoice_items.map((item) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {item?.amount.toFixed(2)} SAR
                          </Text>
                        ))}

                        {ticketData?.result?.enforcements.map((em) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {em?.amount.toFixed(2)} SAR
                          </Text>
                        ))}

                        <Text size="sm" weight={500} color="#817E7E">
                          {invoiceData?.tax} SAR
                        </Text>
                      </Stack>
                    </Group>
                  </ScrollArea>
                </Stack>
                <Space h="xs" />

                <Divider size="sm" />
                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                  <Title size="sm" order={1}>
                    Total
                  </Title>
                  <Title size="sm" order={1}>
                    {invoiceData?.paid_amount.toFixed(2)}
                  </Title>
                  <Title size="sm" order={1}>
                    SAR
                  </Title>
                </Group>
                <Divider size="sm" />

                <Stack>
                  <Title order={5}>Customer Info</Title>
                  <Group>
                    {ticketData?.result?.guest_users === null ? (
                      <Title order={5}>
                        Name:{' '}
                        {!ticketData?.result?.customers?.full_name
                          ? 'Guest'
                          : ticketData?.result?.customers?.full_name}
                      </Title>
                    ) : (
                      <Title order={5}>
                        Name:{' '}
                        {!ticketData?.result?.guest_users?.first_name
                          ? 'Guest'
                          : ticketData?.result?.guest_users?.first_name}
                      </Title>
                    )}
                    <Group>
                      <Input.Label required>Mobile:</Input.Label>
                      {!isMobileEdit ? (
                        <>
                          {ticketData?.result?.guest_users === null ? (
                            <Group>
                              <Title order={5}>
                                {!ticketData?.result?.customers?.country_code?.dial_code
                                  ? '---'
                                  : ticketData?.result?.customers?.country_code?.dial_code}
                              </Title>
                              <Title order={5}>
                                {!ticketData?.result?.customers?.mobile
                                  ? '---'
                                  : ticketData?.result?.customers?.mobile}
                              </Title>
                            </Group>
                          ) : (
                            <Group>
                              <Title order={5}>
                                {!ticketData?.result?.guest_users?.country_code?.dial_code
                                  ? '---'
                                  : ticketData?.result?.guest_users?.country_code?.dial_code}
                              </Title>
                              <Title order={5}>
                                {!ticketData?.result?.guest_users?.mobile
                                  ? '---'
                                  : ticketData?.result?.guest_users?.mobile}
                              </Title>
                            </Group>
                          )}
                        </>
                      ) : (
                        <Input.Wrapper required>
                          <Input
                            id="mobileNumber"
                            // type="number"
                            defaultValue={ticketData?.result?.customers?.mobile}
                            value={inputs?.mobileNumber}
                            onFocus={() => setInputName('mobileNumber')}
                            onChange={onChangeInput}
                            maxLength={12}
                            minLength={7}
                            style={{ width: '110px' }}
                          />
                          {showError && (
                            <Text fz="xs" color="red">
                              Mobile Number min 7 and max 12
                            </Text>
                          )}
                        </Input.Wrapper>
                      )}

                      <ActionIcon>
                        {!isMobileEdit ? (
                          <Edit size={48} strokeWidth={2} color="black" onClick={mobileEdit} />
                        ) : (
                          <EditOff size={48} onClick={mobileEdit} strokeWidth={2} color="black" />
                        )}
                      </ActionIcon>
                    </Group>
                  </Group>
                  <Group px="xl">
                    <Button
                      leftIcon={<Image src={cashIcon} size={14} />}
                      style={{
                        width: '45%',
                        backgroundColor: '#6EAD3A',
                        color: 'white',
                      }}
                      disabled
                    >
                      Cash
                    </Button>
                    <Button
                      leftIcon={<Image src={cardIcon} size={14} />}
                      style={{ width: '45%' }}
                      disabled
                    >
                      Card
                    </Button>
                  </Group>

                  <Group>
                    <Title order={5}>Refund Amount : </Title>
                    <Input
                      value={refundAmount.toFixed(2)}
                      placeholder="Refund Amount"
                      onChange={onChangeInput}
                    />
                  </Group>
                  <Center>
                    <Button
                      style={{ width: '85%', backgroundColor: '#01AA84' }}
                      onClick={() => setConfirmRefund(true)}
                      disabled={refundAmount === Number(0.0)}
                    >
                      Refund
                    </Button>
                  </Center>
                </Stack>
              </Paper>
            ) : (
              <Box>
                <Space h="xl" />
                <Space h="xl" />
                <Space h="xl" />
                <Center p="xl">
                  <Title>Enter Invoice Number & Date to get Invoice Details</Title>
                </Center>
              </Box>
            )}
          </Box>

          <Modal
            opened={confirmRefund}
            centered
            onClose={() => setConfirmRefund(false)}
            title={
              <Text p="xl" className="no-printme">
                Confirm the Refund
              </Text>
            }
          >
            <Box>
              <Center>
                <Title order={1}>Amount : {refundAmount.toFixed(2)} SAR</Title>
              </Center>
              <Center py="xl">
                <Button
                  style={{ width: '40%', backgroundColor: '#01AA84' }}
                  onClick={conirmRefundModel}
                >
                  <Text>Confirm</Text>
                </Button>
              </Center>
            </Box>
          </Modal>

          <Modal opened={verifyRefund} centered onClose={() => setVerifyRefund(false)}>
            <VerifyRefund
              refundAmount={refundAmount}
              selectedVas={selectedVas}
              refundInfo={refundInfo}
              customerMobile={
                isMobileEdit
                  ? getInputValue('mobileNumber')
                  : !ticketData?.result?.customers?.mobile
                  ? ticketData?.result?.guest_users?.mobile
                  : ticketData?.result?.customers?.mobile
              }
              invoiceNumber={invoiceData?.invoice_number || getInputValue('invoiceNumber')}
              invoiceId={invoiceData?.id}
              countryCodeId={
                invoiceData?.country_code?.id ||
                ticketData?.result?.guest_users?.country_code?.id ||
                ticketData?.result?.customers?.country_code?.id ||
                refundInfo?.country_code_id
              }
              passId={invoiceData?.reservations?.pass_id}
              profileData={profileData}
            />
          </Modal>
        </AppShell>
      </div>
    </LandingLayout>
  );
};

export default Refund;
